<template>
	<div style="position:relative">
		<img src="" alt="" v-on:load="_onPreload" v-on:error="_onPreloadError" ref="preloader"
			 style="position: absolute;top: -9999px; width:1px;height:1px"/>

		<div ref="cap" style="width:100%;height:100%;position: absolute;top:0px;left:0px;z-index: 2">
			<div ref="cap1"
				 style="transition: opacity 3s;width:100%;height:100%;position: absolute;top:0px;left:0px; opacity: 0"
			></div>
			<div ref="cap2"
				 style="transition: opacity 3s;width:100%;height:100%;position: absolute;top:0px;left:0px; opacity: 0"
			></div>
		</div>
		<div style="width:100%;height:100%;position: absolute;top:0px;left:0px;z-index: 1">
			<photo ref="photo1" style="width:100%;height:100%;position: absolute;top:0px;left:0px"
				   v-on:photo-load="_photoLoad" v-on:photo-error="_photoError"/>
			<photo ref="photo2" style="width:100%;height:100%;position: absolute;top:0px;left:0px"
				   v-on:photo-load="_photoLoad" v-on:photo-error="_photoError"/>
		</div>

	</div>
</template>

<script>
	import Photo from './Photo';
	import axios from 'axios';
	import isMobile from 'mobile-device-detect';

	export default {
		name: 'PhotoSlider',
		components: {
			Photo
		},
		props: {
			interval: Number
		},
		data() {
			return {
				baseUrl: null,
				conf: null,
				currentGroup: 0,
				currentSrc: 0,
				currentUrl: null,
				currentP: 0,
				currentCap: 0,

				photos: [],
				captions: [],
				inited: false,
				topZ: 1,
				preloadSrc: 0,
				preloadGroup: 0
			}
		},
		methods: {
			_photoLoad() {
				let p = this.photos[this.currentP];
				p.show();
				this.currentP = 1 - this.currentP;
				p = this.photos[this.currentP];
				p.hide();

				let currentCap = this.captions[this.currentCap];
				currentCap.style.opacity = '1';
				currentCap.style.zIndex = this.topZ;
				let backCap = this.captions[1 - this.currentCap];

				if (backCap.style.opacity !== '0') {
					backCap.style.opacity = '0';
					setTimeout(() => {
						backCap.style.display = 'none'
					}, 3000);
				}

				setTimeout(() => this._loadNext(), 5000);

				if (this.inited) return;
				this.inited = true;
				this.$emit("initialised");
				this._preload();
			},
			_photoError() {
				if (!this.inited) return;
				console.log("=================error==============" + this.currentUrl);
				this._loadNext();
			},
			initData(baseUrl, conf) {
				this.baseUrl = baseUrl;
				this.conf = conf;
				this._load();
				this._loadCap();
			},
			_load() {

				let group = this.conf[this.currentGroup];
				// console.log(group.src);
				// let src = group.src[this.currentSrc];
				this.currentUrl = this.baseUrl + group.name + "/" + this._getSrc()[this.currentSrc];
				let p = this.photos[this.currentP];
				p.load(this.currentUrl);
				p.$el.style.zIndex = (this.topZ++) + "";
			},
			_getSrc() {
				let group = this.conf[this.currentGroup];
				return isMobile.isMobile ? group.msrc : group.src;
			},
			_loadNext() {
				let src = this._getSrc();
				this.currentSrc++;

				if (this.currentSrc >= src.length) {
					this.currentSrc = 0;
					this.currentGroup++;
					if (this.currentGroup >= this.conf.length) {
						this.currentGroup = 0;
					}
					this._loadCap();
				}
				this._load();
			},
			_loadCap() {
				this.currentCap = 1 - this.currentCap;
				let cap = this.captions[this.currentCap];
				cap.style.opacity = '0';
				cap.style.display = '';
				cap.innerHTML = "";
				axios
					.get(this.baseUrl + this.conf[this.currentGroup].name + "/caption.html")
					.then(response => {
						// console.log(response.data);
						cap.innerHTML = response.data;
						// this.$refs.slider.initData("https://d.hive.properties/default/slider/",response.data.groups);
					});
			},
			_preload() {
				let group = this.conf[this.preloadGroup];
				let src = (isMobile.isMobile ? group.msrc : group.src);
				this.preloadSrc++;
				let finished=false;

				if (this.preloadSrc >= src.length) {
					this.preloadSrc = 0;
					this.preloadGroup++;
					if (this.preloadGroup >= this.conf.length) {
						finished=true;
					}
				}
				if(!finished){
					group = this.conf[this.preloadGroup];
					let url = this.baseUrl + group.name + "/" + (isMobile.isMobile ? group.msrc : group.src)[this.preloadSrc];
					console.log("preload: "+url);
					this.$refs.preloader.src = url;
				}else{
					console.log("preload finished");
				}

			},
			_onPreload() {
				this._preload();
			},
			_onPreloadError() {
				if(!this.inited)return;
				this._preload();
			}
		},
		mounted() {
			this.photos.push(this.$refs.photo1);
			this.photos.push(this.$refs.photo2);
			this.captions.push(this.$refs.cap1);
			this.captions.push(this.$refs.cap2);

			// console.log(isMobile);
			// this.$refs.photo1.load("https://hive.properties/sackville-4k.jpg");
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
